import { cn } from '@/lib/utils'

interface SettingRowProps {
  label: string
  description?: React.ReactNode
  children: React.ReactNode
  stacked?: boolean
}

export function SettingRow({
  label,
  description,
  children,
  stacked = false,
}: SettingRowProps) {
  return (
    <div
      className={cn(
        'py-3',
        stacked ? 'space-y-2' : 'flex items-center justify-between gap-4',
      )}
    >
      <div className={cn(stacked ? '' : 'flex-1')}>
        <span className="text-sm text-foreground">{label}</span>
        {description && (
          <p className="text-muted-foreground mt-0.5 text-xs">{description}</p>
        )}
      </div>
      {children}
    </div>
  )
}
